// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"SuperZoomImage_imageWrapper__h4WIL","hidden":"SuperZoomImage_hidden__Ziaw_","image":"SuperZoomImage_image__k5Cit","closeButton":"SuperZoomImage_closeButton__wlprU"};